import React, { useState, useEffect, useRef } from 'react'
import { ReactComponent as CloseIcon } from '../img/ic_cerrar.svg';
import { Translate } from '../language';
import CardImgRankingName from './CardImgRankingName';
import searchIcon from '../img/ic__buscador.png'
import ModalMenu from './ModalMenu';
import circle from '../img/circulogris.png';
import { searchFriends } from '../actions/searchActions'
import { connect } from 'react-redux';
import { UseComponentVisible } from './UseComponentVisible'
import ImageNameDescription from '../utils/components/ImageNameDescription/ImageNameDescription';
import Button from '../utils/components/Button/Button';
import InputSearch from '../utils/components/InputSearch/InputSearch';


const ModalTagFriend = ({ setFriendsTag, seeFollowersList, isMark, isMultiplePost, idMultiplePost, friendsTag, displayModal, closeModal, searchFriends, searchList, isLoading, isProfessionalUser }) => {


    const divStyle = {
        display: displayModal ? 'block' : 'none'
    };
    const close = (e) => {
        e.stopPropagation()
        closeModal(e)
    }

    const deleteFriendTag = (id) => {
        setFriendsTag(prevState => {
            var prevStateDelete = prevState
            delete prevStateDelete[id]
            return ({ ...prevStateDelete })
        })
    }
    const {
        ref,
        isComponentVisible,
        setIsComponentVisible
    } = UseComponentVisible(false);

    return (
        <div
            className={"modal modal-tag-friend"}
            onClick={close}
            style={divStyle} >
            <div
                className="modal-content modal-content-tag-friend"
                onClick={e => e.stopPropagation()} >
                <div onClick={close} className="close-modal">
                    <CloseIcon className="cls-1" height="18" width="18" />
                </div>
                <div className=" ml-3 mr-3 mb-5">
                    <div className="text-modal-new-post ">
                        {Translate('tagto', 'es')}
                    </div>
                    <div className="column centerItems mb-2">
                    <InputSearch
                            placeholder={Translate('searchPalcheholder', 'es')}
                            classNameContent=""
                            searchData={(value) => searchFriends(value)}
                            isLoading={isLoading}
                            renderData={searchList && searchList.map(([id,{user}]) =>  !friendsTag[user._id] &&
                                <ImageNameDescription
                                    key={user._id}
                                    onClick={() => {
                                        isMultiplePost ?
                                            setFriendsTag(prevState => { return { ...prevState, [idMultiplePost]: { [user._id]: user } } })
                                            :
                                            setFriendsTag(prevState => { return { ...prevState, [user._id]: user } })
                                    }}
                                    srcImage={user.picture && user.picture.url ? user.picture.url.small : user.picture}
                                    firstName={user.name}
                                    secondName={user.lastname}
                                    description={null}
                                />)}
                        />
                       

                      {/*       <div
                                className="modal-content-button-search-bar"
                                onClick={() =>
                                    setIsComponentVisible(true)
                                }
                            >
                                <div className="search-bar-tag-friend">
                                    <img src={searchIcon} alt="img" className="img-search-bar" />
                                    <input className="input-inside-div" onFocus={(e) => {
                                        searchFriends(e.target.value, null, isMark, isProfessionalUser)
                                    }}
                                        onChange={(e) => {
                                            searchFriends(e.target.value, null, null, isProfessionalUser)
                                        }} type="text" placeholder="Buscar..." />
                                </div>
                            </div>
                            {isComponentVisible &&
                                <div className='scroll-menu modal-search-bar'>
                                    <div className="modal-results-search-bar">
                                        <div>
                                            {isLoading ? <div></div> :
                                                searchList.map(([id,{user}]) => (
                                                    !friendsTag[user._id] &&
                                                    <div
                                                        className="column centerItems text-gray"
                                                        key={user._id}
                                                        onClick={() => {
                                                            isMultiplePost ?
                                                                setFriendsTag(prevState => { return { ...prevState, [idMultiplePost]: { [user._id]: user } } })
                                                                :
                                                                setFriendsTag(prevState => { return { ...prevState, [user._id]: user } })
                                                        }} >
                                                        {user.profilePicture ? <img alt="img" onError={(e) => e.target.src = circle} className="picture-search-bar m-1" src={user.picture}></img> :
                                                            <img alt="img" className="picture-search-bar m-1" src={circle}></img>
                                                        }
                                                        {user.name}
                                                    </div>
                                                ))
                                            }
                                        </div>
                                    </div>
                                </div>
                            } */}
                        
                        <div>
                            <Button onClick={close} text= {Translate('confirm', 'es')}/>
                        </div>
                    </div>
                    {Object.values(friendsTag).length > 0 ?
                        Object.values(friendsTag).map(friend =>
                            <div className="relative">
                              
                                <ImageNameDescription
                                key={friend._id}
                                srcImage={friend.picture && friend.picture.url ? friend.picture.url.small : friend.picture}
                                firstName={friend.name}
                                secondName={friend.lastname}
                                />
                                <div onClick={() =>
                                    deleteFriendTag(friend._id)
                                } className="delete-tag-friends-icon">
                                    <CloseIcon className="cls-1" height="18" width="18" />
                                </div>
                            </div>
                        )
                        :
                        <div>
                            Busca a a tus amigos y etiquetalos
                        </div>}

                </div>
            </div>
        </div>
    );
}


const mapStateToProps = (state) => {
    return {
        searchList: state.users.friendSearchList,
        isLoading: state.users.isLoadingSearchFriendList
    }
}

export default connect(mapStateToProps, { searchFriends })(ModalTagFriend)
